import { createCRUDHook } from './createCRUDHook';
import {
  checkListInstanceDto,
  checkListInstanceCreateDto,
  CheckListInProgressReportDto,
} from 'utils/models';
import { AxiosResponse } from 'axios';
import {
  TBL_CHECKLIST_INSTANCE,
  TBL_CHECKLIST_INSTANCE_CREATE,
  TBL_CHECKLIST_REPORT,
  TBL_CHECKLIST_STEP,
  TBL_CHECKLIST_STEP_COMPLETE,
} from './apiEndPoints';

interface CheckListInstanceCustomOperations {
  GetChecklistReport: () => Promise<CheckListInProgressReportDto[]>;
  getCheckListByOrdreItemId: (orderItemId: number) => Promise<any[]>;
  getCheckListProgress: (id: number) => Promise<any[]>;
  createCheckListInstanceData: (
    param: checkListInstanceCreateDto
  ) => Promise<any>;
  completeCheckListStep: (param: any, stepId: number) => Promise<AxiosResponse>;
  completeCheckList: (id: number, staffId: number) => Promise<AxiosResponse>;
}

const { Context, useManager, useConsumer } = createCRUDHook<
  checkListInstanceDto,
  checkListInstanceDto[],
  CheckListInstanceCustomOperations
>({
  entityName: 'CheckListInstance',
  endpoint: TBL_CHECKLIST_INSTANCE,

  customOperations: (auth) => ({
    GetChecklistReport: async (): Promise<CheckListInProgressReportDto[]> => {
      try {
        const res = await auth.makeAuthenticatedGet(
          TBL_CHECKLIST_INSTANCE + TBL_CHECKLIST_REPORT
        );
        return Promise.resolve(res.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },

    getCheckListByOrdreItemId: async (orderItemId: number): Promise<any[]> => {
      try {
        const res = await auth.makeAuthenticatedGet(
          `${TBL_CHECKLIST_INSTANCE}/orderitem/${orderItemId}`
        );
        return Promise.resolve(res.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },

    getCheckListProgress: async (id: number): Promise<any[]> => {
      try {
        const res = await auth.makeAuthenticatedGet(
          `${TBL_CHECKLIST_INSTANCE}/${id}/progress`
        );
        return Promise.resolve(res.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },

    createCheckListInstanceData: async (
      param: checkListInstanceCreateDto
    ): Promise<any> => {
      try {
        const res = await auth.makeAuthenticatedPost(
          TBL_CHECKLIST_INSTANCE + TBL_CHECKLIST_INSTANCE_CREATE,
          param
        );
        return Promise.resolve(res.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },

    completeCheckListStep: async (
      param: any,
      stepId: number
    ): Promise<AxiosResponse> => {
      try {
        const res = await auth.makeAuthenticatedPut(
          TBL_CHECKLIST_INSTANCE +
            TBL_CHECKLIST_STEP +
            `/${stepId}` +
            TBL_CHECKLIST_STEP_COMPLETE,
          param
        );
        return Promise.resolve(res);
      } catch (error) {
        return Promise.reject(error);
      }
    },

    completeCheckList: async (
      id: number,
      staffId: number
    ): Promise<AxiosResponse> => {
      try {
        const res = await auth.makeAuthenticatedPut(
          `${TBL_CHECKLIST_INSTANCE}/${id}${TBL_CHECKLIST_STEP_COMPLETE}`,
          staffId
        );
        return Promise.resolve(res);
      } catch (error) {
        return Promise.reject(error);
      }
    },
  }),
});

export const CheckListInstanceContext = Context;
export const useCheckListInstanceManager = useManager;
export const useCheckListInstance = useConsumer;
